import { IFilterGridItem } from '@/interfaces/constructor.interfaces';
import {
  IExtendedFilterCollectionItem,
  IFilterBaseOption,
  IFilterColor,
  IFilterColorOption,
  IFilterLocation,
  IFilterModel,
  IFilterModelOption,
  IFilterPrimitive,
  IFilterRange,
  IFilterSpecification,
} from '@/interfaces/filters.interfaces';

export type FilterRecordType =
  | IExtendedFilterCollectionItem
  | IFilterColor
  | IFilterModel
  | IFilterLocation
  | IFilterSpecification
  | IFilterRange
  | IFilterPrimitive;

export type FilterOptionType =
  | IFilterBaseOption
  | IFilterColorOption
  | IFilterModelOption;

export type FilterItemType = Pick<
  IFilterGridItem,
  | 'key'
  | 'path'
  | 'type'
  | 'props'
  | 'dependencies'
  | 'groupByKey'
  | 'hideSingleOption'
  | 'autoSelectSingleOption'
  | 'resetOnChange'
> & {
  /**
   * Выбранное значение фильтра
   */
  value?: unknown;
  /**
   * Идентификаторы фильтров,
   * которые зависят от данного фильтра
   */
  dependents?: IFilterGridItem['key'][];
  /**
   * Флаг выполнения зависимостей для фильтра
   */
  isDependencyFulfilled: boolean;
  /**
   * Текст, который отображается,
   * если зависимости не были выполнены
   */
  dependencyText: string;
  /**
   * Флаг выполнения условий для группировки фильтра
   */
  isGroupFulfilled: boolean;
};

export type GroupedFilterItemType = FilterItemType & {
  /**
   * Заголовок сгруппированного фильтра
   */
  groupTitle?: string;
};

export type FilterItemsType = Array<FilterItemType>;

export type FiltersParametersType = {
  spaceId: string;
  envId: string;
  collectionId: string;
  options?: {
    /** Карта условий для фильтрации */
    fields?: Record<string, string>;
    options?: {
      sort: Array<string>;
    };
  };
  filter?: {
    /** Список ID записей */
    id?: string[];
    /** Список фильтров */
    data?: {
      op: string;
      field: string;
      value?: any;
    }[];
    /** Список выражений для фильтрации */
    q?: Array<string>;
    /**
     * Карта query, которые участвовали в формировании фильтров.
     * Данные необходимы для расчета доступных значений и агрегации фильтров.
     * Поле в запросе на получение фильтров не участвует.
     */
    qMap?: Record<string, string>;
  };
};

export type MarketingInfoParametersType = {
  spaceId: string;
  envId: string;
  collectionId: string;
  options: {
    options: {
      sort: Array<string>;
    };
  };
  filter?: {
    /** Список выражений для фильтрации */
    q?: Array<string>;
  };
};

export type FilterNestedDataType = { key: string; value: unknown };

export type CompositeFilterFieldType = {
  key: string;
  operator?: FilterOperatorsEnum;
  field?: FilterNestedDataType;
};

export type CompositeFilterPathType = {
  path: string;
  field?: FilterNestedDataType;
};

export enum FilterSeparatorSymbolsEnum {
  Operator = '|',
}

export enum FilterOperatorsEnum {
  Min = 'min',
  Max = 'max',
  NestedField = 'nestedField',
}
